import React from 'react';

import { Icon as IconPlanetWithStars } from 'src/assets/icon-planet-with-stars.svg';

export const ReadOnlyLayout = () => {
  return (
    <div className="flex h-full flex-col justify-center gap-2 bg-primary p-8">
      <IconPlanetWithStars />
      <div className="flex flex-col items-center justify-center">
        <h1 className="text-heading-xl">
          This organization hasn’t published any graphs yet
        </h1>
        <p className="pt-1 text-center">
          Graphs will appear on this page once they’re added by a team member
          with publishing access.
        </p>
      </div>
    </div>
  );
};
